export default __webpack_public_path__ + "static/media/minibox_unicorn.fa7107f1.png";